import { DeterminateProgress } from '../../progress';

import { StepperTitle } from './StepperTitle';
import { StepperProps } from './type/Stepper.type';

interface ProgressStepperProps extends Pick<StepperProps, 'title' | 'progressSize'> {
  progressValue: number;
}

export function ProgressStepper({ title, progressValue, progressSize }: ProgressStepperProps) {
  return (
    <div className={'flex flex-col gap-tiny-large pt-normal-small'}>
      {title && <StepperTitle title={title} />}
      <DeterminateProgress value={progressValue} size={progressSize} />
    </div>
  );
}
